//läheb alla kuni leiab

const routes = [
  { 
    path: '/', 
    component: () => import('layouts/AffiliateLayout.vue'),
    children: [
      {
        path: '/set-password/:key',
        name: 'newPassword',
        component: () => import('pages/NewPassword.vue'),
        meta: { 
          auth: false
        }
      },
      {
        path: '/terms-and-conditions',
        name: 'terms',
        component: () => import('pages/Terms.vue'),
        meta: { 
          auth: false
        }
      },
      {
        path: '',
        name: 'aff_overview',
        component: () => import('pages/Overview.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/settings',
        name: 'aff_settings',
        component: () => import('pages/Settings.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/settings/2fa',
        name: 'aff_2fa',
        component: () => import('pages/2FA.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/campaigns',
        name: 'aff_campaigns',
        component: () => import('pages/CampaignsList.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/campaigns/:id',
        name: 'aff_campaign',
        component: () => import('pages/Campaign.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/sell-apis',
        name: 'api_sales',
        component: () => import('pages/ApiSales.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('pages/Login.vue')
      },
      {
        path: '/login/password-recovery',
        name: 'passwordRecovery',
        meta: { title: 'Client area login' },
        component: () => import('pages/PasswordRecovery.vue')
      },
      {
        path: '/performance/daily',
        name: 'aff_performance_daily',
        component: () => import('pages/PerformanceDaily.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/performance/conversions',
        name: 'aff_performance_conversions',
        component: () => import('pages/PerformanceConversions.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/leads',
        name: 'aff_leads',
        component: () => import('pages/LeadsList.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/lead/:id',
        name: 'aff_lead',
        component: () => import('pages/LeadProfile.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/accounting',
        name: 'aff_accounting',
        component: () => import('pages/Accounting.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/stats/remarketing',
        name: 'aff_remarketing',
        component: () => import('pages/RemarketingCampaigns.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/automatic-mails',
        name: 'auto_emails',
        component: () => import('pages/AutomaticEmails.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/automatic-sms',
        name: 'auto_sms',
        component: () => import('pages/AutomaticSms.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/offer-walls',
        name: 'offer_walls',
        component: () => import('pages/WallOffers.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/users',
        name: 'aff_users',
        component: () => import('pages/UserList.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/notifications',
        name: 'aff_notifications',
        component: () => import('pages/Notifications.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/apiconfig',
        name: 'aff_apis',
        component: () => import('pages/ApiConfiguration.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/company/details',
        name: 'aff_info',
        component: () => import('pages/Info.vue'),
        meta: {
          auth: false,
        }
      },
    ]
  }
];

export default routes;
